export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getRegisterUserCount: function getRegisterUserCount() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/statistics/getRegisterUserCount",
        method: "get",
        params: data
      });
    },
    getHouseReleaseCount: function getHouseReleaseCount() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/statistics/getHouseReleaseCount",
        method: "get",
        params: data
      });
    }
  };
});